import { createAction, props } from '@ngrx/store';

import { Policy } from '@lockton-apps/shared/interfaces';
import { Proposal } from '@lockton-apps/shared/interfaces';

export enum PoliciesApiActionTypes {
  LoadPoliciesSuccess = '[Policies API] Load Policies Success',
  LoadPoliciesFailure = '[Policies API] Load Policies Failure',

  LoadClientPoliciesSuccess = '[Policies API] Load Client Policies Success',
  LoadClientPoliciesFailure = '[Policies API] Load Client Policies Failure',

  LoadClientsPoliciesSuccess = '[Policies API] Load Clients Policies Success',
  LoadClientsPoliciesFailure = '[Policies API] Load Clients Policies Failure',

  LoadRecentlyViewedPoliciesSuccess = '[Policies API] Load Recently Viewed Policies Success',
  LoadRecentlyViewedPoliciesFailure = '[Policies API] Load Recently Viewed Policies Failure',

  LoadPolicySuccess = '[Policies API] Load Policy Success',
  LoadPolicyFailure = '[Policies API] Load Policy Failure',

  LoadSeveralSuccess = '[Policies API] Load Several Success',
  LoadSeveralFailure = '[Policies API] Load Several Failure',

  LoadPolicyForPolicyDetailsSuccess = '[Policies API] Load Policy For Policy Details Success',
  LoadPolicyForPolicyDetailsFailure = '[Policies API] Load Policy For Policy Details Failure',

  LoadPoliciesForContactDashboardSuccess = '[Policies API] Load Policies For Contact Dashboard Success',

  LoadPoliciesSuccessThenLoadClientBrokers = '[Policies API] Load Policies Success Then Client Brokers',

  AddedSuccess = '[Policies API] Added Success',
  AddedFailure = '[Policies API] Added Failure',

  UpdatedSuccess = '[Policies API] Updated Success',
  UpdatedFailure = '[Policies API] Updated Failure',

  DeletedSuccess = '[Policies API] Deleted Success',
  DeletedFailure = '[Policies API] Deleted Failure',

  RestoredSuccess = '[Policies API] Restored Success',
  RestoredFailure = '[Policies API] Restored Failure',

  MtaSuccess = '[Policies API] Mta Success',
  MtaFailure = '[Policies API] Mta Failure',
}

export const PoliciesApiActions = {
  loadPoliciesSuccess: createAction(
    PoliciesApiActionTypes.LoadPoliciesSuccess,
    props<{ policies: Policy[] }>()
  ),
  loadPoliciesFailure: createAction(
    PoliciesApiActionTypes.LoadPoliciesFailure,
    props<{ error: unknown }>()
  ),
  loadClientPoliciesSuccess: createAction(
    PoliciesApiActionTypes.LoadClientPoliciesSuccess,
    props<{ policies: Policy[] }>()
  ),
  loadClientPoliciesFailure: createAction(
    PoliciesApiActionTypes.LoadClientPoliciesFailure,
    props<{ error: unknown }>()
  ),
  loadClientsPoliciesSuccess: createAction(
    PoliciesApiActionTypes.LoadClientsPoliciesSuccess,
    props<{ policies: Policy[] }>()
  ),
  loadClientsPoliciesFailure: createAction(
    PoliciesApiActionTypes.LoadClientsPoliciesFailure,
    props<{ error: unknown }>()
  ),
  loadPolicySuccess: createAction(
    PoliciesApiActionTypes.LoadPolicySuccess,
    props<{ policy: Policy }>()
  ),
  loadPolicyFailure: createAction(
    PoliciesApiActionTypes.LoadPolicyFailure,
    props<{ error: unknown }>()
  ),
  loadSeveralSuccess: createAction(
    PoliciesApiActionTypes.LoadSeveralSuccess,
    props<{ policies: Policy[] }>()
  ),
  loadSeveralFailure: createAction(
    PoliciesApiActionTypes.LoadSeveralFailure,
    props<{ error: unknown }>()
  ),
  loadPolicyForPolicyDetailsSuccess: createAction(
    PoliciesApiActionTypes.LoadPolicyForPolicyDetailsSuccess,
    props<{ policy: Policy }>()
  ),
  loadPoliceiesForContactDashboardSuccess: createAction(
    PoliciesApiActionTypes.LoadPoliciesForContactDashboardSuccess,
    props<{ policies: Policy[] }>()
  ),
  loadRecentlyViewedPoliciesSuccess: createAction(
    PoliciesApiActionTypes.LoadRecentlyViewedPoliciesSuccess,
    props<{ policies: Policy[] }>()
  ),
  loadRecentlyViewedPoliciesFailure: createAction(
    PoliciesApiActionTypes.LoadRecentlyViewedPoliciesFailure,
    props<{ error: unknown }>()
  ),
  loadPolicySuccessThenLoadClientBrokers: createAction(
    PoliciesApiActionTypes.LoadPoliciesSuccessThenLoadClientBrokers,
    props<{ policy: Policy }>()
  ),
  mtaSuccess: createAction(
    PoliciesApiActionTypes.MtaSuccess,
    props<{ proposal: Proposal }>()
  ),
  mtaFailure: createAction(
    PoliciesApiActionTypes.MtaFailure,
    props<{ error: unknown }>()
  ),

  addedSuccess: createAction(
    PoliciesApiActionTypes.AddedSuccess,
    props<{ policy: Policy }>()
  ),
  addedFailure: createAction(
    PoliciesApiActionTypes.AddedFailure,
    props<{ error: unknown }>()
  ),
  updatedSuccess: createAction(
    PoliciesApiActionTypes.UpdatedSuccess,
    props<{ policy: Policy }>()
  ),
  updatedFailure: createAction(
    PoliciesApiActionTypes.UpdatedFailure,
    props<{ error: unknown }>()
  ),
  deletedSuccess: createAction(
    PoliciesApiActionTypes.DeletedSuccess,
    props<{ id: number }>()
  ),
  deletedFailure: createAction(
    PoliciesApiActionTypes.DeletedFailure,
    props<{ id: number; error: unknown }>()
  ),
  restoredSuccess: createAction(
    PoliciesApiActionTypes.RestoredSuccess,
    props<{ id: number }>()
  ),
  restoredFailure: createAction(
    PoliciesApiActionTypes.RestoredFailure,
    props<{ id: number; error: unknown }>()
  ),
};
